import { render, staticRenderFns } from "./createRespExterno.vue?vue&type=template&id=48a649c2&scoped=true"
import script from "./createRespExterno.vue?vue&type=script&lang=js"
export * from "./createRespExterno.vue?vue&type=script&lang=js"
import style0 from "./createRespExterno.vue?vue&type=style&index=0&id=48a649c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a649c2",
  null
  
)

export default component.exports